import JobCard from "../job-card/job-card";

import "./professional-experience.css";

const ProfessionalExperience = () => {
	return (
		<>
			<h2>Professional Experience</h2>

			<JobCard
				data={{
					title: "Mid-Level Backend Developer",
					companyName: "Clear Sky Logic",
					start: "March 2024",
					timeline: [
						{
							date: "March 2024",
							tag: "Junior Software Developer 1.1",
						},
						{
							date: "Feburary 2025",
							tag: "Software Developer 1.2",
						},
						{
							date: "October 2025",
							tag: "Mid-Level Software Developer 2.1",
						},
					],
					responsibilities: [
						"Developing and maintaining features using ASP.NET, C#, React & gRPC",
						"Developing and maintaining infrastructure such as Azure Pipelines & infrastructure as code (bicep)",
						"Testing code by writing automated tests such as end to end tests, integration tests & unit tests",
						"Working in an agile team, contributing in daily standups, sprint planning & retrospectives",
						"Mentoring team members into the backend discipline from other disciplines",
						"Working closely with stakeholders to understand the problem and to build a solution",
						"Reviewing team members code, ensuring design patterns are met, maintaining readability"
					],
				}}
			/>
		</>
	);
};

export default ProfessionalExperience;
